import { useEffect, useState } from 'react';
import { X, Link2, MessageCircle } from 'lucide-react';
import { buildWhatsAppShareHref } from '../utils/resolveOfficeWhatsAppHref';
import './EventShareModal.css';

export default function EventShareModal({
  open,
  onClose,
  title,
  subtitle,
  imageUrl,
  shareUrl
}) {
  const [copyLabel, setCopyLabel] = useState('Copy Link');

  useEffect(() => {
    if (!open) return undefined;
    setCopyLabel('Copy Link');
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const url = shareUrl || (typeof window !== 'undefined' ? window.location.href : '');
  const displayTitle = String(title || '').trim() || 'Invincible';
  const displaySubtitle = String(subtitle || '').trim();
  const thumb = String(imageUrl || '').trim();

  const handleCopyLink = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        setCopyLabel('Copied!');
        window.setTimeout(() => setCopyLabel('Copy Link'), 2200);
        return;
      }
    } catch {
      /* fall through */
    }
    window.prompt('Copy this link:', url);
  };

  const handleWhatsApp = () => {
    const lines = [displayTitle, displaySubtitle, url].filter(Boolean);
    const href = buildWhatsAppShareHref(lines.join('\n'));
    if (!href) return;
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className="event-share-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="event-share-title"
      onClick={onClose}
    >
      <div className="event-share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="event-share-header">
          <h2 id="event-share-title" className="event-share-heading">
            Share this Page
          </h2>
          <button
            type="button"
            className="event-share-close modal-close-circle"
            onClick={onClose}
            aria-label="Close share dialog"
          >
            <X size={20} strokeWidth={2} />
          </button>
        </div>

        <div className="event-share-preview">
          {thumb ? (
            <img className="event-share-thumb" src={thumb} alt="" />
          ) : (
            <div className="event-share-thumb event-share-thumb-placeholder" aria-hidden />
          )}
          <div className="event-share-preview-text">
            <p className="event-share-trek-name">{displayTitle}</p>
            {displaySubtitle ? (
              <p className="event-share-trek-tagline">{displaySubtitle}</p>
            ) : null}
          </div>
        </div>

        <div className="event-share-actions">
          <button type="button" className="event-share-action" onClick={handleCopyLink}>
            <Link2 size={18} strokeWidth={2} aria-hidden />
            <span>{copyLabel}</span>
          </button>
          <button type="button" className="event-share-action event-share-action-whatsapp" onClick={handleWhatsApp}>
            <MessageCircle size={18} strokeWidth={2} aria-hidden />
            <span>Whatsapp</span>
          </button>
        </div>
      </div>
    </div>
  );
}
